import { render, staticRenderFns } from "./ColorWithOpacitySelector.vue?vue&type=template&id=5d316fbd&"
import script from "./ColorWithOpacitySelector.vue?vue&type=script&lang=js&"
export * from "./ColorWithOpacitySelector.vue?vue&type=script&lang=js&"
import style0 from "./ColorWithOpacitySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports